@if (availabilityDialog && showrooms) {
  <button
    *transloco="let t"
    app-button="primary-stroked"
    class="check-availability"
    (click)="availabilityDialog.showModal(); init(); clicked.emit()"
  >
    {{ t('Check availability') }}
  </button>
}

<dialog
  #availabilityDialog
  (click)="$event.target === availabilityDialog && availabilityDialog.close()"
>
  <div *transloco="let t" class="container">
    @if (countriesAsDropdown(); as countries) {
      <app-dropdown
        [label]="t('Country')"
        [children]="countries"
        [value]="selectedCountry"
        (valueChange)="onCountryChange($event)"
        [placeholder]="t('Select country')"
        [searchable]="false"
      ></app-dropdown>
    }

    @if (availabilityResult$ | async; as results) {
      <div class="showrooms-grid">
        @for (item of results; track item) {
          <app-showroom-availability [showroomStocks]="item"> </app-showroom-availability>
        }
      </div>
    } @else {
      @if (dataLoaded()) {
        <div class="not-available yes-typography-body">
          {{
            t("We're sorry, but this feature is not available for the selected product.")
          }}
        </div>
      }
    }

    <button
      app-button="icon-button"
      class="close"
      [title]="t('Close')"
      (click)="availabilityDialog.close()"
    >
      <svg-icon key="close"></svg-icon>
    </button>
  </div>
</dialog>
